import Utils, { newWindowEventListeners } from "@/components/shared/util";
import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import { userNamespace } from "@/store/modules/user";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({})
export default class bypass extends Vue {
  @Getter("current", patientNamespace)
  current!: Patient;

  @Getter("showGreenGrayOnly", userNamespace)
  showGreenGrayOnly!: any;

  mounted() {
    const ref = this;
    newWindowEventListeners(ref, "bypass");
  }

  get headerData() {
    const atom = this.current.body.atoms.bypass;
    const bypassText = atom.value > 0 ? "On Bypass" : "Off Bypass";

    return {
      label: bypassText,
      value: atom.legend
    };
  }

  get crossClamp() {
    const atom = this.current.body.atoms.bypassCrossClamp;
    const label =
      atom.value > 0 ? "Cross clamp <b>on</b>" : "Cross clamp <b>off</b>";
    const value = atom.legend.replace("|", " ");
    const color = Utils.getLevelColor(atom.level, this.showGreenGrayOnly);
    return { label, value, color };
  }

  get temp() {
    const atom = this.current.body.atoms.bypassTemp;
    const parts = atom.legend.split("|");
    return { label: parts[0], value: parts[1] };
  }

  get tableData() {
    return [
      { label: "MAP", key: "bypassMAP" },
      { label: "CI", key: "bypassCI" },
      { label: "SVRI", key: "bypassSVR" },
      { label: "VO<sub>2</sub>", key: "bypassVO2" },
      { label: "SvO<sub>2</sub>", key: "bypassSvO2" },
      { label: "Hct pump", key: "bypassHct" },
      { label: "NIRS right", key: "bypassNIRSRight" },
      { label: "NIRS left", key: "bypassNIRSLeft" }
    ].map(item => {
      const atom = this.current.body.atoms[item.key];
      const label = item.label;
      const value = atom.legend.replace("|", " ");
      let color = "";
      if (atom.level === 2 || atom.level == 4) {
        color = "tableYellow";
      }
      if (atom.level == 5 || atom.level === 1) {
        color = "tableRed";
      }

      return { label, value, color };
    });
  }
}
